import { Component } from 'opus-angular-seed-core';


@Component({
    bindings: {
        list: '=',
        loading: '='
    },
    template: `
            <ul class="metacards">
                <li ng-if="!vm.loading" class="metacards__item" ng-repeat="metablock in vm.list.items"
                    ng-class="{'up': metablock.trendData.text === 'Up', 'down': metablock.trendData.text === 'Down'}">
                    <p class="title">{{ vm.getNameTranslated(metablock.name) }} <strong>{{ metablock.value }}</strong></p>
                    <p class="info">
                        <strong>{{ vm.getTrendDataTextTranslated(metablock.trendData.text, metablock.trendData.value)}}</strong> {{ 'report.from last period' | translate }}
                    </p>
                </li>
                <li ng-if="vm.loading" class="metacards__item skeleton" ng-repeat="metablock in vm.skeletonData">
                    <p class="title">{{ metablock.name }}<strong>&nbsp;</strong></p>
                    <p class="info">&nbsp;</p>
                </li>
            </ul>
    `
})
export default class {
    constructor ($translate) {
        this.$translate = $translate;
    }
    $onInit () {
        this.skeletonData = [
            { name: this.$translate.instant('report.Total users') },
            { name: this.$translate.instant('report.Activated users') },
            { name: this.$translate.instant('report.Unique employee logins') },
            { name: this.$translate.instant('report.Courses passed') },
            { name: this.$translate.instant('report.Learning catalogue visits') }
        ];
    }

    getNameTranslated (name) {
        return this.$translate.instant(`report.${name}`);
    }

    getTrendDataTextTranslated (text, value) {
        const textTranslated = this.$translate.instant(`report.${text}`);
        if (value === null) {
            return textTranslated;
        }
        return `${textTranslated} ${value}%`;
    }
}



// WEBPACK FOOTER //
// ./src/app/components/reports/overview/metablocks/index.js